var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods-import"},[_c('bread-crumb',{attrs:{"list":[{
        text: '商品列表',
        url: '/main/goodsLibrary/nav/goodsList'
    }, {
        text: '商品导入'
    }]}}),_c('div',{staticClass:"fx-v-center fx-h-between"},[_c('span',{staticClass:"href fs-14",on:{"click":function($event){_vm.isShowImportRecord = true}}},[_vm._v("导入记录")])]),_c('router-view',{staticClass:"router-view"}),_c('import-record',{attrs:{"visible":_vm.isShowImportRecord},on:{"update:visible":function($event){_vm.isShowImportRecord=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }